import React from 'react';

import styles from '../styles/WarningPanel.module.css';

const WarningPanel = ({ type, text, inTable, buttonText, buttonAction }) => {
  return (
    <div className={`
      ${styles.panel} ${inTable ? styles.inTable : ''} 
      ${type === 'error' ? styles.red : ''} 
      ${type === 'warning' ? styles.blue : ''}
    `}>
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256"><path d="M116,132V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0ZM236,91.55v72.9a19.86,19.86,0,0,1-5.86,14.14l-51.55,51.55A19.85,19.85,0,0,1,164.45,236H91.55a19.85,19.85,0,0,1-14.14-5.86L25.86,178.59A19.86,19.86,0,0,1,20,164.45V91.55a19.86,19.86,0,0,1,5.86-14.14L77.41,25.86A19.85,19.85,0,0,1,91.55,20h72.9a19.85,19.85,0,0,1,14.14,5.86l51.55,51.55A19.86,19.86,0,0,1,236,91.55Zm-24,1.66L162.79,44H93.21L44,93.21v69.58L93.21,212h69.58L212,162.79ZM128,156a16,16,0,1,0,16,16A16,16,0,0,0,128,156Z"></path></svg>
        {text}
      </span>
      {buttonAction && <button type='button' className={styles.button} onClick={buttonAction}>{buttonText}</button>}
    </div>
  )
}

export default WarningPanel;